import '@angular/compiler';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Dexie from 'dexie';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Quill.register('modules/imageResize', ImageResize);

function _window(): any {
  return window;
}

_window().Quill = Quill;
_window().quill = Quill;

_window().dexie = Dexie;
_window().Dexie = Dexie;

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [ provideZoneChangeDetection() ] })
  .catch(err => console.error(err));
